// extracted by mini-css-extract-plugin
export var footer = "_mx-0";
export var inherit = "_mx-1";
export var input = "_mx-2";
export var modalContent = "_mx-3";
export var quillEditor = "_mx-4";
export var subtitle = "_mx-5";